module.exports = __webpack_public_path__ + "static/media/logo.01033c99.svg";